module.exports = __webpack_public_path__ + "static/media/zfp-innowacje.ddcab060.pdf";